import React, {useState} from "react";
import {useNavigate} from "react-router-dom";
import {useSelector} from "react-redux";
import {handleActiveError, handleActiveToast} from "../../../../components/sonner/ToastBasic";
import {isEmpty, validationChecker} from "../../../../components/commonmethod/CommonMethod";
import {createLicense} from "../../../../api/asset/LicenseService";
import Th_title from "../../../../components/Th_title";
import {UserType} from "../../../../constant/CodeSpecNum";
import SimmsInput from "../../../../components/input/SimmsInput";
import {inputOnChange} from "../../../../components/commonmethod/simmsInputMethod";
import SimmsTextArea from "../../../../components/input/SimmsTextArea";
import SearchSelector from "../../../../components/searchSelector/SearchSelector";
import UserSelectionField from "../../../../components/selection/UserSelectionField";
import {dateOnChange} from "../../../../components/commonmethod/simmsDateMethod";
import SimmsDatePicker from "../../../../components/datepicker/SimmsDatePicker";
import dayjs from "dayjs";
import SimmsInputSearch from "../../../../components/input/SimmsInputSearch";
import SimmsDrawerSearch from "../../../../components/drawer/simms/SimmsDrawerSearch";
import {LicenseKeyEditor} from "./shared/LicenseKeyEditor";
import {
    ContentDetailTwoColLayout,
    DetailFilePanel,
    DetailFormPageShell,
    DetailKvReadOnly,
    DetailKvTable,
    DetailListPage,
    DetailPanel,
    DetailSummaryButton,
} from "../../../../components/detailLayout";
import "../../../../components/detailLayout/detailListLayout.css";
import "../info/subPages/view/assetInfo.css";
import "./licenseForm.css";

function LicenseCreate() {
    const platFrom = useSelector((state) => state.auth.platFrom);
    const user = useSelector((state) => state.auth.user);
    const currentDate = new Date();
    const [docs, setDocs] = useState([]);
    const [licenseKeys, setLicenseKeys] = useState([]);
    const [license, setLicense] = useState({quantity: ""});
    const navigate = useNavigate();

    const requireds = ["reqStartDate", "reqEndDate", "licenseStartDate"];

    const addLicenseKey = () => {
        const maxQty = Number(license.quantity);
        if (!maxQty || maxQty <= 0) {
            alert("라이선스 수량 먼저 입력해주세요");
            return;
        }
        if (licenseKeys.length < maxQty) {
            setLicenseKeys((prev) => [...prev, {key: "", asset: {}}]);
        } else {
            alert(`최대 ${maxQty}개의 라이선스 키만 추가할 수 있습니다.`);
        }
    };

    const removeLicenseKey = (index) => {
        setLicenseKeys((prev) => prev.filter((_, i) => i !== index));
    };

    const create = async () => {
        const qty = Number(license.quantity);
        if (!qty || qty <= 0) {
            alert("라이선스 수량을 입력해주세요");
            return;
        }
        if (qty < licenseKeys.length) {
            alert("라이선스 수량은 등록된 키 수 이상이어야 합니다.");
            return;
        }

        const payload = {
            ...license,
            quantity: qty,
        };
        if (!validationChecker(payload)) {
            return;
        }
        if (requireds.some((e) => isEmpty(payload[e]))) {
            alert("필수값이 누락되었습니다.");
            return;
        }
        if (payload.handler?.length === 0 || payload.handler === undefined) {
            handleActiveError({message: "필수값인 담당자가 누락되었습니다."});
            return;
        }

        const docFile = docs.map((each) => each.object);

        try {
            const response = await createLicense(payload, docFile, [], licenseKeys);
            if (response.status === 200) {
                handleActiveToast({message: "등록되었습니다."});
                navigate(`/license/${response.data.id}`, {state: {id: response.data.id}});
            } else if (response.status === 201 || response.status === 202) {
                handleActiveError({message: response.data.title, description: response.data.reason});
            }
        } catch {
            handleActiveError({message: "등록에 실패했습니다."});
        }
    };

    return (
        <DetailFormPageShell
            className="common-container container-height-full border-l-gray create-page detail-list-layout asset-detail-list-layout"
            title="라이선스 등록"
            meta="신규 라이선스 정보를 입력하세요"
            actions={
                <>
                    <DetailSummaryButton muted onClick={() => navigate("/license")}>
                        취소
                    </DetailSummaryButton>
                    <DetailSummaryButton
                        onClick={() => {
                            if (window.confirm("등록 하시겠습니까?")) {
                                create();
                            }
                        }}
                    >
                        등록
                    </DetailSummaryButton>
                </>
            }
        >
            <DetailListPage isEditing className="flex min-h-0 flex-1 flex-col">
                <div className="container-height-body asset-detail-body detail-list-body flex min-h-0 flex-1 flex-col overflow-hidden">
                    <ContentDetailTwoColLayout
                        main={
                        <DetailPanel title="기본정보" className="license-basic-panel">
                            <DetailKvTable>
                                <tbody>
                                    <tr>
                                        <DetailKvReadOnly
                                            label="등록일시"
                                            value={currentDate.toISOString()}
                                            type="date"
                                        />
                                        <DetailKvReadOnly label="수정일시" value="" />
                                    </tr>
                                    <tr>
                                        <DetailKvReadOnly label="등록자" value={user.name} />
                                        <DetailKvReadOnly label="수정자" value="" />
                                    </tr>
                                    <tr>
                                        <Th_title
                                            title="라이선스 명칭"
                                            colspan={3}
                                            required
                                            className="fieldset-td"
                                            auth
                                        >
                                            <SimmsInput
                                                onChange={(v) => inputOnChange(setLicense, "title", v, true)}
                                                data={license.title}
                                            />
                                        </Th_title>
                                    </tr>
                                    <tr>
                                        <Th_title
                                            title="라이선스 사용기간"
                                            colspan={3}
                                            className="fieldset-td fieldset-td-input"
                                            required
                                            auth
                                        >
                                            <div className="web-flex asset-detail-date-range">
                                                <SimmsDatePicker
                                                    onChange={(v) =>
                                                        dateOnChange(setLicense, "reqStartDate", v, true)
                                                    }
                                                    data={license.reqStartDate}
                                                    constraint={{
                                                        lessThan: license.reqEndDate && dayjs(license.reqEndDate),
                                                        required: true,
                                                    }}
                                                    auth
                                                />
                                                <span className="asset-detail-date-range-sep">~</span>
                                                <SimmsDatePicker
                                                    onChange={(v) =>
                                                        dateOnChange(setLicense, "reqEndDate", v, true)
                                                    }
                                                    data={license.reqEndDate}
                                                    constraint={{
                                                        largerThan:
                                                            license.reqStartDate && dayjs(license.reqStartDate),
                                                        required: true,
                                                    }}
                                                    auth
                                                />
                                            </div>
                                        </Th_title>
                                    </tr>
                                    <tr className="license-kv-row--intro-handler">
                                        <Th_title
                                            title="라이선스 도입일시"
                                            colspan={1}
                                            className="fieldset-td"
                                            required
                                            auth
                                        >
                                            <SimmsDatePicker
                                                onChange={(v) =>
                                                    dateOnChange(setLicense, "licenseStartDate", v, true)
                                                }
                                                data={license.licenseStartDate}
                                                constraint={{required: true}}
                                                auth
                                            />
                                        </Th_title>
                                        <Th_title
                                            title="담당자"
                                            colspan={1}
                                            className="fieldset-td fieldset-td-input"
                                            required
                                            auth
                                        >
                                            <UserSelectionField
                                                layout="inline"
                                                data={license.handler}
                                                onRemove={(v) =>
                                                    setLicense((prev) => ({
                                                        ...prev,
                                                        handler: (prev.handler ?? []).filter((h) => h.id !== v.id),
                                                    }))
                                                }
                                            >
                                                <SearchSelector
                                                    auth
                                                    multiSelect
                                                    variant="compact"
                                                    entity="userAccount"
                                                    uniqueKey={UserType.handlers}
                                                    data={license.handler}
                                                    placeHolder="사용자명"
                                                    onChange={(v) => {
                                                        if (v?.__multiFlat) {
                                                            setLicense((prev) => ({
                                                                ...prev,
                                                                handler: v.__multiFlat,
                                                            }));
                                                        }
                                                    }}
                                                >
                                                    <SimmsInputSearch type="TEXT" placeHolder="사용자명" />
                                                    <SimmsDrawerSearch
                                                        showLabel
                                                        title="부서"
                                                        entity="department"
                                                        target="department"
                                                        recursive
                                                    />
                                                    <SimmsDrawerSearch
                                                        showLabel
                                                        title="업체"
                                                        entity="company"
                                                        target="company"
                                                    />
                                                </SearchSelector>
                                            </UserSelectionField>
                                        </Th_title>
                                    </tr>
                                    <tr className="asset-detail-kv-row--auto license-kv-row--keys">
                                        <Th_title title="라이선스 키" colspan={3} className="fieldset-td" auth>
                                            <LicenseKeyEditor
                                                licenseKeys={licenseKeys}
                                                quantity={license.quantity}
                                                onQuantityChange={(v) =>
                                                    inputOnChange(setLicense, "quantity", v, true)
                                                }
                                                isEditing
                                                fieldAuth
                                                platFrom={platFrom}
                                                onAdd={addLicenseKey}
                                                onRemove={(_, index) => removeLicenseKey(index)}
                                                onKeyChange={(index, value) => {
                                                    setLicenseKeys((prev) => {
                                                        const next = [...prev];
                                                        next[index] = {...next[index], key: value};
                                                        return next;
                                                    });
                                                }}
                                                onAssetChange={(index, asset) => {
                                                    setLicenseKeys((prev) => {
                                                        const next = [...prev];
                                                        next[index] = {...next[index], asset};
                                                        return next;
                                                    });
                                                }}
                                            />
                                        </Th_title>
                                    </tr>
                                    <tr>
                                        <Th_title title="비고사항" colspan={3} className="fieldset-td" auth>
                                            <SimmsTextArea
                                                onChange={(v) => inputOnChange(setLicense, "etc", v, true)}
                                                data={license.etc}
                                                style={{width: "100%", minHeight: "80px"}}
                                            />
                                        </Th_title>
                                    </tr>
                                </tbody>
                            </DetailKvTable>
                        </DetailPanel>
                        }
                        aside={
                        <DetailFilePanel
                            title="첨부"
                            isEditing
                            pendingFiles={{files: docs, setFiles: setDocs}}
                            pendingInputId="license_create_doc"
                        />
                        }
                    />
                </div>
            </DetailListPage>
        </DetailFormPageShell>
    );
}

export default LicenseCreate;
